export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.slice(reader.result.indexOf(';base64,') + 8, reader.result.length))
    reader.onerror = error => reject(error)
  })
}
